<template>
  <div>
    <select
      v-model="selected"
      class="form-control"
      tabindex="3"
      :class="{ 'is-invalid': error,'form-control':true}"
    >
      <option value="undefined">Seleccione</option>
      <option 
        v-for="(option, index) in options"
        v-bind:value="option.value"
        :key="index"  
      >{{ option.text }}</option>
    </select>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../../helpers/config"

export default {
  props: {
    onClick: Function,
    departament_id: Number,
    error: Boolean
  },
  watch: {
    selected: function(newVal, oldVal) {
      // watch it
      this.onClick(newVal);
    },
    departament_id(val) {
      this.selected = val
    }
  },
  mounted() {
    this.getDepartaments();
  },
  data() {
    return {
      selected: undefined,
      options: []
    };
  },
  methods: {
    onChange(event) {
      this.onClick(event.value);
    },
    getDepartaments() {
      axios
        .get(`${config.urlApi}/locationDepartments`, {})
        .then(response => {
          response.data.forEach(element => {
            
            this.options.push({
              value: element.locationDepartmentId,
              text: element.department
            });
          });
        })
        .catch(function(error) {});
    }
  }
};
</script>
